/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedNullSearchResults_viewer$ref = any;
export type BuySharedNullSearchResults_viewer = {
    readonly isShopByRoomEnabled: boolean | null;
    readonly " $refType": BuySharedNullSearchResults_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedNullSearchResults_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isShopByRoomEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SHOP_BY_ROOM"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
    }
  ]
};
(node as any).hash = '7452343a61ff5a8017a57bfc4cc2e2b5';
export default node;
